module.exports = __webpack_public_path__ + "img/blog-13.0059581c.webp";